import React from "react"
import Footer from "./Footer"
import PropTypes from "prop-types"

const BackgroundHelper = props => {
  return (
    <div>
      <div className="main-page-description">
        <div className="container custom-container">
          <div className="bg-container justify-content-center">
            {props.layout}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BackgroundHelper

BackgroundHelper.propTypes = {
  layout: PropTypes.any,
}
